// Connect page entry. Imports the SCSS bundle so Vite emits the same
// stylesheet for every page, then wires the form micro-interactions on top
// of the shared site setup (theme, nav, noise, footer meta).

import '../scss/master.scss';

// Reuse all the setup* functions from master.js by importing it for side
// effects. master.js's init() runs against whatever DOM is present, so it
// gracefully no-ops on the bits the connect page doesn't have (.split-word,
// horizontal-timeline, etc.).
import './master.js';

// ---------- Connect-form micro-interactions --------------------------------
function setupConnectForm() {
  const form = document.querySelector('.connect-form');
  if (!form) return;

  const status = form.querySelector('#form-status');
  const submitBtn = form.querySelector('button[type="submit"]');

  // Live character counter for the textarea
  form.querySelectorAll('[data-counter-target]').forEach((counter) => {
    const targetId = counter.dataset.counterTarget;
    const target = document.getElementById(targetId);
    if (!target) return;
    const update = () => {
      counter.textContent = String(target.value.length);
    };
    target.addEventListener('input', update);
    update();
  });

  // Floating-label trick: add a class when the field has any value so the
  // CSS knows whether to lift the label.
  form.querySelectorAll('input, textarea, select').forEach((field) => {
    const sync = () => {
      field.classList.toggle('has-value', !!field.value && field.value !== '');
    };
    field.addEventListener('input', sync);
    field.addEventListener('change', sync);
    field.addEventListener('blur', sync);
    sync();
  });

  // Submit via fetch so we can show success state in-place rather than
  // navigating to Web3Forms's default thank-you page.
  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    // HTML5 validity first — let the browser highlight bad fields
    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    // Honeypot: if it's filled, silently bail
    const botcheck = form.querySelector('input[name="botcheck"]');
    if (botcheck && botcheck.checked) return;

    // Guard against submitting before a real Web3Forms key has been
    // configured — the placeholder string causes a 400 from Web3Forms
    // which is unfriendly.
    const accessKey = form.querySelector('input[name="access_key"]')?.value;
    if (!accessKey || accessKey.includes('REPLACE_WITH')) {
      setStatus('error', 'Form key not configured. Email hello@shabirhussain.com instead.');
      return;
    }

    submitBtn.classList.add('is-loading');
    submitBtn.disabled = true;
    setStatus('pending', 'Sending…');

    try {
      const data = new FormData(form);
      const res = await fetch(form.action, {
        method: 'POST',
        body: data,
        headers: { Accept: 'application/json' },
      });
      const json = await res.json().catch(() => ({}));

      if (res.ok && json.success !== false) {
        form.reset();
        form.querySelectorAll('.has-value').forEach((el) => el.classList.remove('has-value'));
        setStatus('success', 'Sent. I’ll be in touch within 1–2 business days.');
        submitBtn.classList.remove('is-loading');
        submitBtn.classList.add('is-success');
        // Ease the success state back to default after a beat
        setTimeout(() => submitBtn.classList.remove('is-success'), 4000);
      } else {
        const msg = json.message || 'Couldn’t send right now. Email hello@shabirhussain.com directly?';
        setStatus('error', msg);
        submitBtn.classList.remove('is-loading');
      }
    } catch (err) {
      setStatus('error', 'Network hiccup. Try again or email hello@shabirhussain.com.');
      submitBtn.classList.remove('is-loading');
    } finally {
      submitBtn.disabled = false;
    }
  });

  function setStatus(kind, text) {
    if (!status) return;
    status.textContent = text;
    status.dataset.state = kind; // CSS hooks: pending | success | error
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setupConnectForm);
} else {
  setupConnectForm();
}
